<script lang="ts" setup>
const props = defineProps<{
  sticky?: boolean;
}>();
</script>

<template>
  <header class="ds-navbar" :class="{ 'ds-navbar--sticky': props.sticky }">
    <div v-if="$slots.burger" class="ds-navbar__burger">
      <slot name="burger" />
    </div>
    <div class="ds-navbar__brand">
      <slot name="brand" />
    </div>
    <div class="ds-navbar__start">
      <slot name="start" />
    </div>
    <div class="ds-navbar__end">
      <slot name="end" />
    </div>
  </header>
</template>

<style lang="scss" scoped>
@use "bulma/sass/utilities/initial-variables" as bulma;

.ds-navbar {
  display: flex;
  align-items: center;
  min-height: 56px;
  padding: $spacing_3 $spacing_5;
  background: $white;
  border-bottom: 1px solid $border-landing_border;
  gap: $spacing_4;
}

.ds-navbar--sticky {
  position: sticky;
  top: 0;
  z-index: 10;
}

.ds-navbar__burger {
  display: none;
  flex-shrink: 0;
}

// Burger is mobile-only — matches DesignSystemSidebar's own breakpoint
// (Bulma's $tablet), not an independent number that can drift out of sync.
@media (width < #{bulma.$tablet}) {
  .ds-navbar__burger {
    display: flex;
  }
}

.ds-navbar__brand {
  flex-shrink: 0;
  color: $tertiary;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
}

.ds-navbar__start {
  flex: 1;
  @include ds-cluster($spacing_4);
}

.ds-navbar__end {
  position: relative;
  @include ds-cluster($spacing_4);
  flex-shrink: 0;
}
</style>
